export const TOPBAR = {
    SHOW_SEARCH_BUTTON: 'TOPBAR.SHOW_SEARCH_BUTTON',

    SHOW_SEARCH_BAR: 'TOPBAR.SHOW_SEARCH_BAR',

    SHOW: 'TOPBAR.SHOW',

    HAS_NAV_MENU: 'TOPBAR.HAS_NAV_MENU',

    SET_NAV_LIST: 'TOPBAR.SET_NAV_LIST',

    SET_REFRESH_FUNCTION: 'TOPBAR.SET_REFRESH_FUNCTION',

    SET_BUTTONS: 'TOPBAR.SET_BUTTONS',

    SET_MENU_ITEMS: 'TOPBAR.SET_MENU_ITEMS',

    SET_SEARCH_PLACE_HOLDER: 'TOPBAR.SET_SEARCH_PLACE_HOLDER',

    SET_SEARCH_TEXT: 'TOPBAR.SET_SEARCH_TEXT',

    SHOW_BACK_BUTTON: 'TOPBAR.SHOW_BACK_BUTTON',

    SHOW_HOME_BUTTON: 'TOPBAR.SHOW_HOME_BUTTON'
}